import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

import type { MondayBoardColumn } from '../../types/integrations';

interface Props {
  label: string;
  value: string | undefined;
  columns: MondayBoardColumn[];
  isLoading: boolean;
  disabled?: boolean;
  onChange: (value: string) => void;
}

const ColumnSelect = ({ label, value, columns, isLoading, disabled, onChange }: Props) => (
  <div className="flex items-center gap-3">
    <Label className="w-36 shrink-0 text-xs font-semibold uppercase tracking-widest text-text-subtle">{label}</Label>
    <Select value={value ?? ''} onValueChange={onChange} disabled={isLoading || columns.length === 0 || disabled}>
      <SelectTrigger className="flex-1 normal-case font-normal">
        <SelectValue placeholder="Selecciona columna" />
      </SelectTrigger>
      <SelectContent>
        {columns.map((col) => (
          <SelectItem key={col.id} value={col.id}>
            <span>{col.title}</span>
            <span className="ml-2 text-xs text-text-subtle font-mono opacity-60">{col.id}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export default ColumnSelect;
